import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import DropDown from '@/components/profile/dropDown'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/idVerification/constants"
import { capitalizeFirstLetter } from "@/utils"

import '@/pages/profile/sections/common.css'

export default function IsUnderGraduate(props: any) {
    const { profile } = useLocalTranslation();
    const isUnderGraduateOptions = [
        {
            value: "Yes",
            label: "Yes"
        },
        {
            value: "No",
            label: "No"
        }
    ];


    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            <p className='commonH2'>
                {profile.fields.finishedUndergraduateDegree}
                <span className='text-[#FF2828]'>*</span>
            </p>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }

            <DropDown
                options={isUnderGraduateOptions}
                value={props.value}
                onChange={(e: any) => props.handleInputChange(e, listOfSections.isUnderGraduate)}
                placeholder={profile.placeHolders.finishedUndergraduateDegree}
                customDropDownIcon={true}
            />

            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.isUnderGraduate)}
                />
            </div>
        </div>
    );
}
